import Grid from '@material-ui/core/Grid';
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { userLockStatus } from '../../../common/enumerations/user-lock-status';
import { ILoginUser } from '../../../common/interfaces/dtos/ILoginUser';
import { ILoginUserErrors } from '../../../common/interfaces/dtos/ILoginUserErrors';
import { IButton } from '../../../common/interfaces/IButton';
import { AppState } from '../../../common/redux/configure-store';
import LoginForm, { ILoginFormProps } from '../../../login-form/login-form';
import ResetPassword from '../../../reset-password/reset-password';
import EmeraldSignage from '../emerald-signage';
import RegisterForm, { IRegisterFormProps } from '../register-form';
import { useStyles } from './user-login-styles';

const UserLogin: React.FC<IUserLoginProps> = (props: IUserLoginProps): JSX.Element => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { showResetPassword } = useSelector((store: AppState) => store.resetPassword);

  const supervisorLogin = props.lockStatus === userLockStatus.Supervisor;
  const showLabel = props.showPasswordLabel;
  let label = '';

  /* Conditional statements for picking to either show Password as the label in selling service
     on login page or the other options when in R10
  */
  if (showLabel) {
    label = 'UserPassword';
  } else {
    if (supervisorLogin) {
      label = 'SupervisorPinCode';
    } else {
      label = 'PinCode';
    }
  }

  const loginProps: ILoginFormProps = {
    userLabel: t(supervisorLogin ? 'SupervisorUserId' : 'UserIdLabel'),
    passwordLabel: t(label),
    ...props,
  };

  const registerProps: IRegisterFormProps = {
    cancelButton: props.alternateButton,
    ...props,
  };

  return (
    <Grid container className={classes.gridcontaineruser} data-testid='user-login'>
      <EmeraldSignage
        welcomeClick={(): void => {
          props.toggleWelcomeVisible();
        }}
        trainingMode={props.trainingMode}
      />
      {showResetPassword ? (
        <ResetPassword user={props.user} setUser={props.setUser} onSubmit={props.onSubmit} />
      ) : props.showTpId ? (
        <RegisterForm {...registerProps} />
      ) : (
        <LoginForm {...loginProps} />
      )}
    </Grid>
  );
};

interface IUserLoginProps {
  alternateButton: IButton;
  submitButton: IButton;
  errors: ILoginUserErrors;
  user: ILoginUser;
  setUser: (state: ILoginUser) => void;
  setErrors: (state: ILoginUserErrors) => void;
  handleIAMLogin: (iamUser: ILoginUser) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  lockStatus: userLockStatus;
  lockLabel?: string;
  showTpId: boolean;
  showBuId: boolean;
  showPasswordLabel?: boolean;
  toggleWelcomeVisible: () => void;
  trainingMode?: boolean;
  setLoginDate?: (date: string) => void;
  setLoginTime?: (time: string) => void;
}

export default UserLogin;
